import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import type { CentrixSchemas } from "core/entities/CentrixTypes";

export type PitstopAlertType =
  CentrixSchemas["Fixhub.PitstopAlerts.PitstopAlertType"];
export type PitstopAlertDto =
  CentrixSchemas["Fixhub.PitstopAlerts.PitstopAlertDto"];
export type PitstopAlertTranslationDto =
  CentrixSchemas["Fixhub.PitstopAlerts.PitstopAlertTranslationDto"];
export type PitstopAlertTranslationCreateDto =
  CentrixSchemas["Fixhub.PitstopAlerts.PitstopAlertTranslationCreateDto"];
export type PitstopAlertConfigurationDto =
  CentrixSchemas["Fixhub.PitstopAlerts.PitstopAlertConfigurationDto"];
export type PitstopAlertConfigurationSummaryDto =
  CentrixSchemas["Fixhub.PitstopAlerts.PitstopAlertConfigurationSummaryDto"];
export type ActivePitstopAlertDto =
  CentrixSchemas["Fixhub.PitstopAlerts.ActivePitstopAlertDto"];
export type ActivePitstopAlertResultDto =
  CentrixSchemas["Fixhub.PitstopAlerts.ActivePitstopAlertResultDto"];

export const VALID_ALERT_TYPES: Exclude<PitstopAlertType, "Invalid">[] = [
  "Important",
  "Warning",
  "Update",
  "Document",
  "Event",
];

export const ALERT_SEVERITY_MAP: Record<
  PitstopAlertType,
  "error" | "warning" | "success" | "info"
> = {
  Invalid: "error",
  Important: "error",
  Warning: "warning",
  Update: "success",
  Document: "info",
  Event: "warning",
};

export const ALERT_TYPE_CONFIG: Record<
  Exclude<PitstopAlertType, "Invalid">,
  { icon: React.ReactElement; color: string }
> = {
  Important: { icon: <ErrorOutlineIcon />, color: "error.main" },
  Warning: { icon: <WarningAmberIcon />, color: "warning.main" },
  Update: { icon: <InfoOutlinedIcon />, color: "success.main" },
  Document: { icon: <DescriptionOutlinedIcon />, color: "info.main" },
  Event: { icon: <CalendarMonthIcon />, color: "warning.dark" },
};

export function getAlertTypeConfig(type?: PitstopAlertType | null) {
  if (!type || type === "Invalid") {
    return null;
  }
  return ALERT_TYPE_CONFIG[type] ?? null;
}

export function resolveAlertTranslation(
  translations: PitstopAlertTranslationDto[] | null | undefined,
  locale: string
): PitstopAlertTranslationDto | undefined {
  if (!translations?.length) {
    return undefined;
  }
  return (
    translations.find((t) => t.locale === locale) ??
    translations.find((t) => t.locale === "en") ??
    translations[0]
  );
}
